import { ref } from '@vue/composition-api';
import { $api } from '@/store/ApiClient';
import { generateUuid } from '@/utils/searchUtil.js';

export function useBffTradingUnitSearch(initialQueries = {}, immediate = true) {
  const data = ref(null);
  const loading = ref(false);
  const error = ref(null);
  const cancelRequestSources = [];
  const tag = generateUuid();
  cancelRequestSources.push(tag);
  let requestSeq = 0;

  const fetchData = async (queries = initialQueries) => {
    const mySeq = ++requestSeq;
    loading.value = true;
    error.value = null;
    const params = {
      lslConfig: {
        serviceCode: 'tw-transaction-bff-api',
        apiCode: 'get_/v1/tradings/tradingUnitSearch',
        query: {
          tradingId: queries.tradingId,
          tradingName: queries.tradingName,
          ownerSectionIds: queries.ownerSectionIds,
          flowUpdateDateFrom: queries.flowUpdateDateFrom,
          flowUpdateDateTo: queries.flowUpdateDateTo,
          limit: queries.limit,
          offset: queries.offset
        }
      },
      tag: cancelRequestSources,
    };
    try {
      const res = await $api.request(params);
      if (mySeq !== requestSeq) return;
      data.value = res;
    } catch (err) {
      if (mySeq !== requestSeq) return;
      error.value = err;
    } finally {
      if (mySeq === requestSeq) loading.value = false;
    }
  };

  if (immediate) fetchData();

  return {
    data,
    loading,
    error,
    refresh: fetchData,
  };
}
